import React from 'react'
import ReactDOM from 'react-dom'
import { Redirect, globalHistory } from 'common-tools/ReachRouter'
import Login from 'common-views/Security/Login'
import DrawerContainer from 'common-views/Drawer/DrawerContainer'
import UnknownRoute from 'common-views/Security/UnknownRoute'
import { store } from 'common-data/store'
import { Provider as ReduxProvider } from 'react-redux'
import { RoutePush } from 'common-data/Actions/ReduxRouterActions'
import ReduxToastr from 'react-redux-toastr'
import { SiteRouter } from 'common-classes/SiteRouter'
import { AdminRoute } from './adminroute'
import { AppRoute } from './approute'
import { MeRoute } from './meroute'
import { SetDeviceFingerPrint } from './Data/Actions/CurrentSessionActions'
import { GetDeviceFingerPrint } from './Tools/SecurityHelper'
import { DemoRoute } from './demoroute'
import { createRoot } from 'react-dom/client';
globalHistory.listen((history) => {
  store.dispatch(RoutePush(history.location.pathname, history.location.search, history.location.hash))
})

window.addEventListener('DOMContentLoaded', async (event) => {
  const id = await GetDeviceFingerPrint()
  store.dispatch(SetDeviceFingerPrint(id))
})

if (window.Cypress) {
  window.store = store
}

class Main extends React.Component {
  render () {
    return (
      <React.Fragment>
        <SiteRouter>
          <Redirect from="/" to="/App" />
          <Login path='/Login' />
          <AppRoute path='/App/*' />
          <AdminRoute path='/Admin/*' />
          <MeRoute path='/Me/*' />
          <Redirect from="/Demo" to="/Demo/TabBox" />
          <DemoRoute path='/Demo/:Name/*' />
          <UnknownRoute default />
        </SiteRouter>
        <ReduxToastr
          timeOut={4000}
          newestOnTop={true}
          preventDuplicates
          position="bottom-left"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
          closeOnToastrClick />
        <DrawerContainer />
      </React.Fragment>

    )
  }
}

// ReactDOM.render(
//   <ReduxProvider store={store}>
//     <Main />
//   </ReduxProvider>
//   , document.getElementById('content'))

const container = document.getElementById('content');
const root = createRoot(container);

root.render(
  <ReduxProvider store={store}>
    <Main />
  </ReduxProvider>
);
